var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('DashboardSchedule',{attrs:{"loaded":_vm.loaded,"officers":_vm.officers,"roles":_vm.roles,"crm-setting-value":_vm.crmSettingValue,"user":_vm.user}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }